import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { LocalStorageService } from '@core/local-storage/local-storage.service';
import { DialogService } from '@core/services/dialog.service';
import { MessageService } from '@core/services/message.service';
import { VinculoService } from '@core/services/vinculo.service';
import { VinculoSharedDataService } from '@modules/vinculo/vinculo-shared-data.service';
import {
  areArraysEqual,
  converterItensVaziosEmNull,
  removerDuplicados,
} from '@shared/util/util';
import { Location } from '@angular/common';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { FormService } from '@core/services/form.service';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { NotificationService } from '@core/services/notification.service';
import { TipoContatoEnum, TipoEntidadeEnum } from '@core/models/entidade';
import { RoleEnum } from '@core/models/role';
import { PerfilEnum } from '@core/models/perfil';
import { AuthenticationService } from '@core/auth/authentication.service';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { TipoVinculoEnum } from '@core/models/vinculo';
import { AtualizacaoContatoVinculoModalComponent } from '@modules/vinculo/components/atualizacao-contato-vinculo-modal/atualizacao-contato-vinculo-modal.component';
import { EntidadesService } from '@core/services/entidades.service';
import { PessoaService } from '@core/services/pessoa.service';
import { Subject, takeUntil, distinctUntilChanged, filter } from 'rxjs';
import { LoaderService } from '@shared/components/loader/loader.service';

@Component({
  selector: 'app-vinculo-form',
  templateUrl: './vinculo-form.component.html',
  styleUrls: ['./vinculo-form.component.scss'],
})
export class VinculoFormComponent implements OnInit, OnDestroy {
  @ViewChild('formElement') formElement!: ElementRef;

  @Input() isModal: boolean = false;
  @Input() pessoa: any;
  @Input() idEntidade!: number;
  @Input() tipoEntidadeId: number | null = null;
  @Input() acao: RouteAction = RouteAction.Inserir;
  @Input() obj: any;
  @Input() form!: FormGroup;
  @Input() idVinculo!: number;

  private destroy$ = new Subject<void>();
  private pessoaCarregadaId: number | null = null;
  /** Contatos, grupos e documentos entram depois dos campos de texto. */
  conteudoSecundario = false;
  carregandoComplemento = false;
  carregandoPessoa = false;

  contato: any;
  dataSet: any[] = [];
  vinculo: any;
  current = 0;

  vinculoForm!: FormGroup;
  nomePagina: NomePaginaEnum = NomePaginaEnum.VINCULO;

  idParams!: number;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  actionActual!: RouteAction;
  sucesso: boolean = false;
  validatFormDadosBasicos: string[] = [];
  sinalizarCamposInvalidos: boolean = false;
  roleEnum = RoleEnum;
  perfilEnum = PerfilEnum;
  tipoVinculoEnum = TipoVinculoEnum;
  tipoEntidadeEnum = TipoEntidadeEnum;
  dadosIdSelecionado: any;
  entidadeIdSelecionado: any;
  pessoaIdSelecionado: any;
  podeCadastrarEditar: boolean = false;
  perfilUsuarioLogado: any;
  perfisPodemEditar: boolean = false;
  isLotacaoAdm: boolean = true;
  endereco: any;
  vinculos: any;
  entidadeList: any[] = [];
  entidadeNome: any;
  mostrarModal: any;
  pessoaVinculada: any;
  private vinculoCompletoCarregado = true;
  private idVinculoCarregado: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private vinculoSharedDataService: VinculoSharedDataService,
    private vinculoService: VinculoService,
    private fb: FormBuilder,
    private location: Location,
    private formService: FormService,
    private modalService: NzModalService,
    private router: Router,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
    private entidadeService: EntidadesService,
    private pessoaService: PessoaService,
    private loaderService: LoaderService,
  ) {}

  ngOnInit(): void {
    this.checkUrl();
    this.getParams();
    this.construirForm();

    this.isPerfilUsuarioLogado();

    const acaoRota = this.route.snapshot.data['acao'] ?? this.acao;
    if (acaoRota) {
      this.acao = acaoRota;
    }
    this.inserir = this.acao == RouteAction.Inserir;
    this.editar = this.acao == RouteAction.Editar;
    this.visualizar = this.acao == RouteAction.Visualizar;

    if (this.editar || this.visualizar) {
      this.carregandoComplemento = true;
      this.carregandoPessoa = true;
      this.idParams = this.route.snapshot.params['id'];
      this.buscarDados();
    } else {
      this.liberarConteudoSecundario();
    }

    this.pessoaIdControl?.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        distinctUntilChanged(),
        filter((value): value is number => typeof value === 'number')
      )
      .subscribe((value) => {
        this.pessoaIdSelecionado = value;
        this.carregarPessoaVinculada(value);
      });

    this.entidadeIdControl?.valueChanges
      .pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((value) => {
      this.entidadeIdSelecionado = value;
      if (this.entidadeIdSelecionado) {
        this.vinculoService
          .podeCadastrarVinculo(this.entidadeIdSelecionado)
          .subscribe((res) => {
            this.podeCadastrarEditar = res;
          });
      }
    });
    this.inserir = this.acao == RouteAction.Inserir;
    this.editar = this.acao == RouteAction.Editar;
    this.visualizar = this.acao == RouteAction.Visualizar;

    this.tipoVinculoIdControl?.valueChanges
      .pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((value) => {
      if (value == TipoVinculoEnum.Lotacao) {
        this.isLotacaoAdm =
          this.perfilUsuarioLogado === PerfilEnum.Administrador ||
          this.perfilUsuarioLogado == PerfilEnum.Validador;
      } else {
        this.isLotacaoAdm = true;
      }
    });

    this.verificarPessoaEntidade();
  }

  private carregarPessoaVinculada(id: number): void {
    if (this.pessoaCarregadaId === id && this.pessoaVinculada) {
      this.carregandoPessoa = false;
      return;
    }
    this.carregandoPessoa = true;
    this.pessoaCarregadaId = id;
    this.pessoaService.buscarPorId(id).subscribe({
      next: (pessoa) => {
        this.pessoaVinculada = pessoa;
        this.carregandoPessoa = false;
      },
      error: () => {
        this.carregandoPessoa = false;
      },
    });
  }

  private checkUrl() {
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
    });
  }
  construirForm() {
    this.vinculoForm = this.fb.group({
      entidadeId: [],
      pessoaId: [],
      nomePessoa: [],
      tipoVinculoId: [],
      cargoReferenciaIds: [],
      dataInicioMandato: [],
      dataFimMandato: [],
      dataInicioVinculo: [],
      dataFimVinculo: [],
      federacaoIndicadoraId: [],
      vinculoEfetivoSuplenteId: [],
      vinculoPessoaCargoEfetivo: [],
      empresaLocacaoTerceiro: [],
      flagVinculoPrincipal: [],
      areaAtuacaoPessoaEntidadeLotada: [],
      lotacaoVinculo: [],
      statusValidacaoId: [],
      cargoPessoaEntidadeRepresentada: [],
      entidadeRepresentadaId: [],
      justificativa: [],
      vinculoContatos: [],
      vinculoDocumentos: [],
      vinculoGrupos: [],
      idPessoa: [],
      id: [''],
    });

    this.dadosModal();
  }

  buscarDados() {
    if (this.idParams || this.obj?.id) {
      if (this.acao == RouteAction.Visualizar) {
        this.visualizar = true;
      }

      let idParams = this.idParams ?? this.obj.id;
      if (this.idVinculo) {
        idParams = this.idVinculo;
      }

      this.loaderService.show();
      this.vinculoCompletoCarregado = false;
      this.carregandoComplemento = true;
      this.idVinculoCarregado = idParams;
      this.vinculoService.buscarPorIdBasico(idParams).subscribe({
        next: (res) => {
          this.aplicarDadosBasicos(res);
          this.loaderService.suppressAutomaticLoader();
          this.carregarComplemento(idParams);
        },
        error: () => {
          this.loaderService.hide();
          this.carregandoComplemento = false;
          this.carregandoPessoa = false;
        }
      });
    }
  }

  private aplicarDadosBasicos(res: any): void {
    const pessoaIdNum = res?.pessoaId ?? null;
    res.idSelectPessoa = pessoaIdNum;
    res.cargoReferenciaIds = res?.cargoReferenciaIds?.length
      ? res.cargoReferenciaIds
      : res?.cargoReferenciaId
        ? [res.cargoReferenciaId]
        : [];
    res.vinculoContatos = res.vinculoContatos ?? [];
    res.vinculoDocumentos = res.vinculoDocumentos ?? [];
    res.vinculoGrupos = res.vinculoGrupos ?? [];

    this.vinculo = res;
    this.contato = this.vinculo.vinculoContatos;
    this.dataSet = this.contato;

    if (pessoaIdNum) {
      this.pessoaIdSelecionado = pessoaIdNum;
    }
    if (res.entidadeId) {
      this.entidadeIdSelecionado = res.entidadeId;
      this.entidadeList = [
        {
          id: res.entidadeId,
          nome: res.nomeEntidade ?? res.nomeFantasia ?? String(res.entidadeId),
          tipoEntidadeId: res.tipoEntidadeId,
        },
      ];
      this.entidadeNome = res.nomeEntidade;
    }

    this.vinculoForm.patchValue(res, { emitEvent: false });
    this.vinculoForm.markAsPristine();

    if (pessoaIdNum) {
      this.carregarPessoaVinculada(pessoaIdNum);
    } else {
      this.carregandoPessoa = false;
    }
  }

  private carregarComplemento(idParams: number): void {
    this.vinculoService.buscarPorId(idParams, true).subscribe({
      next: (full) => {
        this.aplicarComplemento(full);
        this.carregandoComplemento = false;
        this.liberarConteudoSecundario();
      },
      error: () => {
        this.vinculoCompletoCarregado = false;
        this.carregandoComplemento = false;
        this.liberarConteudoSecundario();
      }
    });
  }

  private aplicarComplemento(full: any): void {
    if (!full) {
      this.vinculoCompletoCarregado = true;
      return;
    }
    const pessoaIdAtual = this.vinculo?.pessoaId ?? this.vinculo?.idSelectPessoa;
    this.vinculo = {
      ...this.vinculo,
      ...full,
      pessoaId: pessoaIdAtual ?? full.pessoaId,
      idSelectPessoa: pessoaIdAtual ?? full.pessoaId,
      tipoEntidadeId: this.vinculo?.tipoEntidadeId ?? full.tipoEntidadeId,
    };
    this.contato = this.vinculo.vinculoContatos;
    this.dataSet = this.contato;
    this.preencherSeNaoEditado('vinculoContatos', full.vinculoContatos ?? []);
    this.preencherSeNaoEditado('vinculoDocumentos', full.vinculoDocumentos ?? []);
    this.preencherSeNaoEditado('vinculoGrupos', full.vinculoGrupos ?? []);
    this.preencherSeNaoEditado('vinculoCargosReferencia', full.vinculoCargosReferencia ?? []);
    const cargosAtuais = this.vinculoForm.get('cargoReferenciaIds')?.value;
    this.preencherSeNaoEditado(
      'cargoReferenciaIds',
      full.cargoReferenciaIds?.length ? full.cargoReferenciaIds : cargosAtuais,
    );
    this.vinculoCompletoCarregado = true;
  }

  private preencherSeNaoEditado(campo: string, valor: any): void {
    const control = this.vinculoForm.get(campo);
    if (!control || control.dirty) {
      return;
    }
    control.setValue(valor, { emitEvent: false });
    control.markAsPristine();
  }

  private garantirComplemento(continuar: () => void): void {
    if (this.vinculoCompletoCarregado || this.inserir) {
      continuar();
      return;
    }
    const id = this.idVinculoCarregado ?? this.idParams ?? this.vinculo?.id;
    if (!id) {
      continuar();
      return;
    }
    this.vinculoService.buscarPorId(id, true).subscribe({
      next: (full) => {
        this.aplicarComplemento(full);
        continuar();
      },
      error: () => {
        this.notificationService.warn(
          'Atenção!',
          'Não foi possível carregar todos os dados do vínculo. Tente salvar novamente.'
        );
      },
    });
  }

  private liberarConteudoSecundario(): void {
    setTimeout(() => {
      this.conteudoSecundario = true;
    });
  }

  dadosModal() {
    if (this.isModal && (this.idEntidade || this.pessoa)) {
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;

      if (!this.editar && !this.visualizar) {
        if (this.idEntidade) {
          this.vinculoForm.get('entidadeId')?.disable();
        }

        if (this.pessoa) {
          this.vinculoForm.get('pessoaId')?.disable();
        }

        this.buscarDados();

        this.vinculoForm.patchValue({
          pessoaId: this.pessoa ? this.pessoa?.nome : null,
          entidadeId: this.idEntidade ?? null,
        });

        this.dadosIdSelecionado = { ...this.vinculoForm.getRawValue() };
      }
    } else {
      this.buscarDados();
    }
  }

  submit() {
    const messages = this.formService.getValidationsMessages(
      this.vinculoForm,
      this.formElement,
    );
    this.formService.validateAllFormFields(this.vinculoForm);

    if (messages.length) {
      const camposObrigatorios = this.getCamposObrigatoriosNaoPreenchidos(
        this.vinculoForm,
      );

      this.notificationService.warn(
        'Atenção!',
        `Existem campos obrigatórios a serem preenchidos: ${camposObrigatorios.join(', ')}.`,
      );
      return;
    }

    // Adicionando log detalhado para verificar os erros do formulário
    if (!this.vinculoForm.valid) {
      // console.log('Formulário inválido');

      // Logando os erros de cada campo individualmente
      Object.keys(this.vinculoForm.controls).forEach((field) => {
        const control = this.vinculoForm.get(field);
        if (control && control.invalid) {
          console.log(`Erro no campo ${field}:`, control.errors);
        }
      });

      return;
    }

    // Se o formulário for válido, chama o método done
    this.garantirComplemento(() => this.done());
  }

  getCamposObrigatoriosNaoPreenchidos(formGroup: FormGroup): string[] {
    const camposNaoPreenchidos: string[] = [];

    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);

      if (control?.invalid && control?.errors?.['required']) {
        const elementoDOM = document.querySelector(
          `[formControlName="${key}"]`,
        );
        const label =
          elementoDOM?.getAttribute('nzPlaceHolder') ||
          this.getNomeAmigavelCampo(key);
        camposNaoPreenchidos.push(label);
      }
    });

    return camposNaoPreenchidos;
  }

  getNomeAmigavelCampo(campo: string): string {
    const nomeAmigavel = campo.charAt(0).toUpperCase() + campo.slice(1);
    return `<strong style="color: red;">${nomeAmigavel}</strong>`;
  }

  done(): void {
    let objEnvio = { ...this.vinculoForm.getRawValue() };

    const datas = [
      'dataInicioMandato',
      'dataFimMandato',
      'dataInicioVinculo',
      'dataFimVinculo',
    ];
    datas.forEach((data) => {
      if (objEnvio[data]) {
        objEnvio[data] = dayjs(objEnvio[data]).format(
          'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
        );
      }
    });

    if (this.deveDesmarcarVinculoPrincipal(objEnvio.dataFimVinculo)) {
      objEnvio.flagVinculoPrincipal = false;
      this.vinculoForm
        .get('flagVinculoPrincipal')
        ?.setValue(false, { emitEvent: false });
    }

    if (objEnvio?.vinculoOutrosContatos) {
      const contatosValidos = objEnvio.vinculoOutrosContatos.filter(
        (contato: any) => contato && typeof contato === 'object',
      );

      if (!Array.isArray(objEnvio.vinculoContatos)) {
        objEnvio.vinculoContatos = [objEnvio.vinculoContatos];
      }

      if (
        contatosValidos.length === 1 &&
        objEnvio.vinculoContatos.length === 1 &&
        !objEnvio.vinculoContatos[0].flagPrincipal
      ) {
        objEnvio.vinculoContatos = contatosValidos;
      } else {
        objEnvio.vinculoContatos =
          objEnvio.vinculoContatos.concat(contatosValidos);
        objEnvio.vinculoContatos = objEnvio.vinculoContatos.filter(
          (contato: { id: any }, index: any, self: any[]) =>
            index === self.findIndex((t) => t.id === contato.id),
        );
      }

      delete objEnvio.vinculoOutrosContatos;
    }

    if (!Array.isArray(objEnvio?.vinculoContatos)) {
      objEnvio.vinculoContatos = [objEnvio?.vinculoContatos];
    }

    if (objEnvio?.vinculoContatos) {
      objEnvio?.vinculoContatos?.forEach((contato: any) => {
        if (contato?.flagPrincipal) {
          contato.tipoContato = { id: TipoContatoEnum.ENDERECO };
        }
      });
    }

    if (objEnvio?.tipoVinculoId !== 2) {
      objEnvio.dataInicioMandato = null;
      objEnvio.dataFimMandato = null;
    }

    objEnvio.vinculoContatos = removerDuplicados(objEnvio.vinculoContatos);

    objEnvio.cargoReferenciaIds = Array.isArray(objEnvio.cargoReferenciaIds)
      ? objEnvio.cargoReferenciaIds
      : objEnvio.cargoReferenciaIds
        ? [objEnvio.cargoReferenciaIds]
        : [];
    objEnvio.cargoReferenciaId = objEnvio.cargoReferenciaIds[0] ?? null;
    objEnvio = converterItensVaziosEmNull(objEnvio);

    objEnvio.vinculoContatos = objEnvio.vinculoContatos.map(
      (contato: any) => contato ?? {},
    );

    this.confirmarEnvio(objEnvio);
  }

  private confirmarEnvio(objEnvio: any): void {
    const confirmar = (mensagem: string) =>
      this.dialogService.confirm(mensagem, () => {
        if (objEnvio.id) {
          this.editarSubmit(objEnvio);
        } else {
          this.salvarSubmit(objEnvio);
        }
      });

    const pessoaId = objEnvio?.pessoaId;
    const ehNovoVinculoNaoPrincipal =
      !objEnvio?.id && !objEnvio?.flagVinculoPrincipal;

    if (ehNovoVinculoNaoPrincipal && typeof pessoaId === 'number') {
      this.pessoaService.possuiVinculoPrincipal(pessoaId).subscribe({
        next: (possuiVinculoPrincipal) => {
          confirmar(
            possuiVinculoPrincipal
              ? this.getMensagemConfirmacaoSubmit(objEnvio)
              : this.getMensagemConfirmacaoCadastroSemVinculoPrincipal(objEnvio),
          );
        },
        error: () => confirmar(this.getMensagemConfirmacaoSubmit(objEnvio)),
      });
      return;
    }

    confirmar(this.getMensagemConfirmacaoSubmit(objEnvio));
  }

  getMensagemConfirmacaoCadastroSemVinculoPrincipal(objEnvio: any): string {
    const nomePessoa = objEnvio?.nomePessoa ?? objEnvio?.pessoaId ?? '';

    return `Vínculo será criado, porém a pessoa <b>${nomePessoa}</b> continuará sem vínculo principal. Deseja realmente continuar?`;
  }

  private getMensagemConfirmacaoSubmit(objEnvio: any): string {
    if (this.isEncerrandoVinculoPrincipal(objEnvio)) {
      const nomePessoa =
        this.vinculo?.nomePessoa ??
        objEnvio?.nomePessoa ??
        objEnvio?.pessoaId ??
        '';

      return `O registro da pessoa <b>${nomePessoa}</b> não possuirá vínculo principal e você estará removendo esse vínculo neste momento. Deseja realmente continuar?`;
    }

    if (this.isRemovendoVinculoPrincipal(objEnvio)) {
      const nomePessoa =
        this.vinculo?.nomePessoa ??
        objEnvio?.nomePessoa ??
        objEnvio?.pessoaId ??
        '';
      const nomeEntidade =
        this.vinculo?.nomeEntidade ?? this.entidadeNome ?? '';

      return `Você deseja realmente remover o vínculo <b>Principal</b> da pessoa <b>${nomePessoa}</b> na entidade <b>${nomeEntidade}</b>?`;
    }

    return `Deseja realmente ${objEnvio.id ? 'editar' : 'cadastrar'} vínculo?`;
  }

  private isRemovendoVinculoPrincipal(objEnvio: any): boolean {
    return (
      !!objEnvio?.id &&
      this.vinculo?.flagVinculoPrincipal === true &&
      objEnvio?.flagVinculoPrincipal === false
    );
  }

  private isEncerrandoVinculoPrincipal(objEnvio: any): boolean {
    if (
      !objEnvio?.id ||
      this.vinculo?.flagVinculoPrincipal !== true ||
      !objEnvio?.dataFimVinculo
    ) {
      return false;
    }

    const hoje = dayjs().startOf('day');
    const dataFimVinculo = dayjs(objEnvio.dataFimVinculo).startOf('day');

    return (
      dataFimVinculo.isValid() &&
      (dataFimVinculo.isBefore(hoje) || dataFimVinculo.isSame(hoje))
    );
  }

  private deveDesmarcarVinculoPrincipal(dataFimVinculo: any): boolean {
    if (!dataFimVinculo) {
      return false;
    }

    const hoje = dayjs().startOf('day');
    const dataFim = dayjs(dataFimVinculo).startOf('day');

    return (
      dataFim.isValid() &&
      (dataFim.isBefore(hoje) || dataFim.isSame(hoje))
    );
  }

  salvarSubmit(objEnvio: any) {
    this.vinculoService.salvar(objEnvio).subscribe((res) => {
      this.idParams = res.id;
      this.sucesso = true;
      this.messageService.success(`Vínculo salvo com sucesso!!!`);
      this.resetFormularios();
      this.modalService.closeAll();
    });
  }

  editarSubmit(objEnvio: any) {
    console.log(objEnvio);

    let modalFechado = false;

    const originalObj = this.vinculo.vinculoContatos;
    const previousObj = objEnvio.vinculoContatos;

    // Verificando se os objetos são iguais ou não
    const isEqual = areArraysEqual(originalObj, previousObj);
    // console.log('Comparando os arrays vinculoContatos:', originalObj, previousObj);
    // console.log('isEqual:', isEqual);
    // console.log('flagVinculoPrincipal:', objEnvio.flagVinculoPrincipal);

    // Verificando a condição de entrar no bloco
    if (!isEqual && objEnvio.flagVinculoPrincipal) {
      // console.log('Entrando no bloco do if porque isEqual é false e flagVinculoPrincipal é true');

      // Buscando vinculos por Vinculo Principal
      this.vinculoService
        .buscarPorVinculoPrincipal(objEnvio.id)
        .subscribe(async (res) => {
          // console.log('Resposta do serviço buscarPorVinculoPrincipal:', res);
          this.vinculos = res;

          // Verificando se há vinculos e contatos válidos
          if (
            this.vinculos &&
            this.vinculos.length > 0 &&
            objEnvio.vinculoContatos.some(
              (contato: any) => contato.flagPrincipal,
            )
          ) {
            // console.log('Exibindo o modal para atualizar endereço dos registros');
            this.modalService.confirm({
              nzTitle:
                'Deseja atualizar o endereço das pessoas que estão utilizando o contato do registro Principal nos demais registros?',
              nzOkText: 'Sim',
              nzCancelText: 'Não',
              nzOnOk: async () => {
                modalFechado = await this.showModal(this.vinculos, objEnvio);
                // console.log('Modal fechado:', modalFechado);

                if (modalFechado) {
                  this.modalFechadoFn(objEnvio);
                }
              },
              nzOnCancel: () => {
                // console.log('Modal cancelado');
                modalFechado = true;
                this.modalFechadoFn(objEnvio);
              },
            });
          } else {
            // console.log('Nenhum vínculo ou contatos válidos encontrados');
            modalFechado = true;
            if (modalFechado) {
              this.modalFechadoFn(objEnvio);
            }
          }
        });
    } else {
      // console.log('Condição não atendida para entrar no if: isEqual é true ou flagVinculoPrincipal é false');
      this.modalFechadoFn(objEnvio);
    }
  }

  modalFechadoFn(objEnvio: any) {
    // console.log('Função modalFechadoFn chamada com objEnvio:', objEnvio);
    this.idParams = objEnvio.id;

    // Editando vinculo
    this.loaderService.releaseAutomaticLoader();
    this.vinculoService.editar(objEnvio).subscribe((res) => {
      this.loaderService.suppressAutomaticLoader();

      if (this.endereco) {
        // console.log('Editando vinculoContatos com endereco:', this.endereco);
        this.vinculoService
          .editarVinculoVinculoContatos(this.endereco)
          .subscribe();
      }

      this.sucesso = true;
      let msg =
        this.perfilUsuarioLogado == PerfilEnum.Atualizador
          ? 'Alteração enviada para aprovação.'
          : 'Vínculo editado com sucesso!!!';
      // console.log('Mensagem de sucesso:', msg);
      this.messageService.success(msg);

      // Resetando formulários após sucesso
      this.resetFormularios();
      this.modalService.closeAll();
    }, () => {
      this.loaderService.suppressAutomaticLoader();
    });
  }

  modalVoltar(): void {
    this.modalService.confirm({
      nzTitle: 'Deseja voltar para página de consulta?',
      // nzContent: 'Os dados não salvos serão perdidos.',
      nzOkText: 'Sim',
      nzCancelText: 'Não',
      nzOnOk: () => {
        this.voltar();
      },
      nzOnCancel: () => {
        if (this.inserir) {
          this.router.navigate([`/vinculo/editar/${this.idParams}`]);
        } else {
          this.buscarDados();
        }
      },
    });
  }

  resetFormularios() {
    this.vinculoSharedDataService.setResetForm(true);
    this.modalVoltar();
  }

  atualizarObjeto(
    objOriginal: { [x: string]: any },
    objNovo: { [x: string]: any; hasOwnProperty: (arg0: string) => any },
  ) {
    for (const chave in objNovo) {
      if (
        objNovo.hasOwnProperty(chave) &&
        objOriginal[chave] !== objNovo[chave]
      ) {
        objOriginal[chave] = objNovo[chave];
      }
    }
  }

  receberDadosContato(event: any) {
    if (event) {
      this.vinculoForm.get('vinculoContatos')?.setValue(event);
    }
  }

  switchStatus(index: number) {
    switch (true) {
      case index === this.current:
        return 'process';
      case index < this.current:
        return 'finish';
      case index > this.current:
        return 'wait';
      default:
        return 'wait';
        break;
    }
  }

  voltar(): void {
    this.isModal ? this.modalService.closeAll() : this.location.back();
  }

  getParams(service?: any) {
    if (!this.isModal) {
      this.route.params.subscribe((data) => {
        this.idParams = data['id'];
      });

      this.route.data.subscribe((data) => {
        this.acao = data['acao'];
        this.inserir = this.acao == RouteAction.Inserir;
        this.editar = this.acao == RouteAction.Editar;
        this.visualizar = this.acao == RouteAction.Visualizar;
      });
    }
  }

  isPerfilUsuarioLogado() {
    this.perfilUsuarioLogado =
      this.authenticationService.currentUserValue?.perfil?.perfil;
    this.perfisPodemEditar =
      this.perfilUsuarioLogado === PerfilEnum.Administrador ||
      this.perfilUsuarioLogado === PerfilEnum.Atualizador ||
      this.perfilUsuarioLogado === PerfilEnum.Validador;
  }

  showModal(vinculos?: any[], objEnvio?: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const config: ModalOptions<AtualizacaoContatoVinculoModalComponent> = {
        nzTitle: 'Registros  que Utilizam o Endereço da do registro principal',
        nzContent: AtualizacaoContatoVinculoModalComponent,
        nzCentered: true,
        nzFooter: null,
        nzMaskClosable: false,
        nzWidth: '50vw',
        nzBodyStyle: {
          height: '200px',
          width: '100%',
          overflow: 'auto',
        },
        nzOnOk: () => resolve(true),
        nzOnCancel: () => resolve(false),
        nzClosable: false,
      };

      const modalRef = this.modalService.create(config);
      modalRef.componentInstance!.novoContato = objEnvio.vinculoContatos.find(
        (contato: any) => contato.flagPrincipal,
      );
      modalRef.componentInstance!.vinculos = this.vinculos;
      modalRef.componentInstance!.idVinculoPrincipal = this.vinculo.id;

      modalRef.afterClose.subscribe((result: any) => {
        resolve(true);
        this.endereco = result;
      });
    });
  }

  goToPessoa() {
    const pessoaId = this.getPessoaId();
    if (pessoaId) {
      this.router.navigate([`/pessoa/editar/${pessoaId}`]);
      if (this.isModal) {
        this.modalService.closeAll();
      }
      return;
    }

    this.notificationService.warn('Atenção!', `Pessoa não encontrada.`);
  }

  goToEntidade() {
    const entidadeId = this.getEntidadeId();
    if (entidadeId) {
      this.router.navigate([`/entidade/editar/${entidadeId}`]);
      if (this.isModal) {
        this.modalService.closeAll();
      }
      return;
    }

    this.notificationService.warn('Atenção!', `Entidade não encontrada.`);
  }

  exibirBotaoIrParaPessoa(): boolean {
    if (!this.getPessoaId()) {
      return false;
    }

    if (this.isModal) {
      return !this.pessoa;
    }

    return this.editar || this.visualizar;
  }

  exibirBotaoIrParaEntidade(): boolean {
    if (!this.getEntidadeId()) {
      return false;
    }

    if (this.isModal) {
      return !this.idEntidade;
    }

    return this.editar || this.visualizar;
  }

  getPessoaId(): number | null {
    if (typeof this.pessoaIdSelecionado === 'number') {
      return this.pessoaIdSelecionado;
    }

    if (this.pessoaVinculada?.id) {
      return this.pessoaVinculada.id;
    }

    if (this.vinculo?.idSelectPessoa) {
      return this.vinculo.idSelectPessoa;
    }

    if (this.obj?.idPessoa) {
      return this.obj.idPessoa;
    }

    return null;
  }

  getEntidadeId(): number | null {
    if (this.idEntidade) {
      return this.idEntidade;
    }

    if (typeof this.entidadeIdSelecionado === 'number') {
      return this.entidadeIdSelecionado;
    }

    const entidadeIdFormulario = this.vinculoForm?.getRawValue()?.entidadeId;
    if (typeof entidadeIdFormulario === 'number') {
      return entidadeIdFormulario;
    }

    if (typeof this.vinculo?.entidadeId === 'number') {
      return this.vinculo.entidadeId;
    }

    if (this.obj?.idEntidade) {
      return this.obj.idEntidade;
    }

    return null;
  }

  verificarPessoaEntidade(): boolean {
    if (this.pessoa || this.idEntidade) {
      return true;
    }
    return false;
  }

  ngOnDestroy(): void {
    this.loaderService.releaseAutomaticLoader();
    this.destroy$.next();
    this.destroy$.complete();
  }

  get pessoaIdControl() {
    return this.vinculoForm.get('pessoaId');
  }

  get entidadeIdControl() {
    return this.vinculoForm.get('entidadeId');
  }

  get tipoVinculoIdControl() {
    return this.vinculoForm.get('tipoVinculoId');
  }
}
